export default class RapsoError extends Error {
  constructor(data, code, message) {
    super(message || "An unknown error occured");
    this.name = "RapsoError";
    if (code !== undefined) {
      this.code = code;
    }
    if (message !== undefined) {
      this.message = message;
    }
    this.data = data;
    if (!code && !message) {
      this.generateAutomaticErrorCode(data);
    }
  }
  generateAutomaticErrorCode(err_data) {
    this.code = "UNKNOWN_ERROR";
    this.message = "An unknown error occured";
    // Track unicity constraint error
    if (err_data.code && err_data.code === "ALREADY_EXISTS") {
      this.code = "VALIDATION_ERROR";
      this.message = "Unicity constraint error";
      return;
    }
    // Track protected resource can not delete a document
    if (err_data.code && err_data.code === "PROTECTED_RESOURCE") {
      this.code = "PROTECTED_RESOURCE";
      this.message = err_data.message;
      return;
    }

    if (err_data.detail) {
      this.code = err_data.detail;
      return;
    }
    // Automatically get from axios response
    if (!err_data.response) {
      return;
    }
    if (err_data.response.data.code) {
      this.code = err_data.response.data.code;
    }
    if (err_data.message) {
      this.message = err_data.response.data.message;
    }
  }
}
